import axios from 'axios';

/**
 * Thin wrappers over /api/website/. Every call names the organization, like the rest of
 * the app (organizations.permissions.get_current_organization).
 */
const base = '/api/website/';

const withOrg = (orgId, extra = {}) => ({ params: { organization: orgId, ...extra } });

export const websiteApi = {
  config: (orgId) => axios.get(base, withOrg(orgId)),
  content: (orgId) => axios.get(`${base}content/`, withOrg(orgId)),
  patchContent: (orgId, body) => axios.patch(`${base}content/`, body, withOrg(orgId)),
  previewToken: (orgId) => axios.get(`${base}preview-token/`, withOrg(orgId)),
  generate: (orgId) => axios.post(`${base}generate/`, {}, withOrg(orgId)),
  regenerate: (orgId, field) => axios.post(`${base}regenerate/`, { field }, withOrg(orgId)),
  job: (orgId, jobId) => axios.get(`${base}jobs/${jobId}/`, withOrg(orgId)),
  publish: (orgId) => axios.post(`${base}publish/`, {}, withOrg(orgId)),
  unpublish: (orgId) => axios.post(`${base}unpublish/`, {}, withOrg(orgId)),
  restore: (orgId, publicationId) => axios.post(`${base}restore/`, { publication_id: publicationId }, withOrg(orgId)),
  publications: (orgId) => axios.get(`${base}publications/`, withOrg(orgId)),
  stats: (orgId) => axios.get(`${base}stats/`, withOrg(orgId)),
  confirm: (orgId) => axios.post(`${base}confirm/`, {}, withOrg(orgId)),
  images: (orgId) => axios.get(`${base}images/`, withOrg(orgId)),
  uploadImage: (orgId, file) => {
    const form = new FormData();
    form.append('file', file);
    return axios.post(`${base}images/`, form, { ...withOrg(orgId), headers: { 'Content-Type': 'multipart/form-data' } });
  },
  patchImage: (orgId, imageId, body) => axios.patch(`${base}images/${imageId}/`, body, withOrg(orgId)),
  deleteImage: (orgId, imageId) => axios.delete(`${base}images/${imageId}/`, withOrg(orgId)),
};

export const isJobActive = (job) => Boolean(job) && (job.status === 'queued' || job.status === 'running');
